export const datetime = (val) => {
    if (!val) return '';

    let date = window.moment(val);

    return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : '';
}



// WEBPACK FOOTER //
// ./src/filters/index.js